import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import media from '../../../utils/mediaQueries';

import { ReviewFormContainer } from './ReviewFormContainer';
import { SuccessMessage } from '../SuccessMessage';
import stores from '../../../stores';
import { SUCCESS_MESSAGE_BODY } from './formDictionary';
import { UserSchool } from './types/UserSchool';

const Container = styled.div`
  background: #fff;
  border-radius: 10px;
  margin: 24px 0;

  ${media.mobile`
    margin: 24px -8px;
  `}
`;

type SchoolReviewFormProps = {
  schoolId: string;
  placeId: string;
  userSchools: UserSchool[];
  minCommentLength: number;
};

const SchoolReviewForm = observer((props: SchoolReviewFormProps) => {
  useEffect(() => {
    stores.schoolReviewStore.setPlaceId(props.placeId);

    return () => stores.schoolReviewStore.resetReviewStore();
  }, []);
  const {
    isSent, placeId, rating, reviewId,
  } = stores.schoolReviewStore;

  return (
    <Container>
      {isSent
        ? <SuccessMessage text={SUCCESS_MESSAGE_BODY} placeId={placeId} rating={rating} reviewId={reviewId} />
        : <ReviewFormContainer {...props} />}
    </Container>
  );
});

export { SchoolReviewForm };
